import { createSlice } from '@reduxjs/toolkit';
import {
	createDTE,
	readDTEFacele,
	loginWarehouseDTE,
	createWarehouseGuide,
	getWarehouseGuides,
	getWarehouseGuide,
	cancelWarehouseGuide,
} from './thunk';

export const initialState = {
	// Auth DTE
	isDTEAuthLoading: false,
	isDTEAuthSuccess: false,
	isDTEAuthError: false,
	dteAuth: null,

	// Create DTE
	isCreatingDTE: false,
	isCreatedDTE: false,
	isCreateDTEError: false,
	createdDTE: null,

	// Read DTE Facele
	isReadingDTEFacele: false,
	isReadDTEFacele: false,
	isReadDTEFaceleError: false,
	dteFacele: null,

	// Warehouse Guide (war_guide collection)
	guides: [],
	currentGuide: null,
	isLoading: false,
	isCreated: false,

	error: null,
};

const WarehouseGuideSlice = createSlice({
	name: 'WarehouseGuide',
	initialState,
	reducers: {
		clearGuideState: state => {
			state.isCreated = false;
			state.error = null;
		},
	},
	extraReducers: builder => {
		builder.addCase(loginWarehouseDTE.pending, state => {
			state.isDTEAuthLoading = true;
			state.isDTEAuthSuccess = false;
			state.isDTEAuthError = false;
			state.dteAuth = null;
		});
		builder.addCase(loginWarehouseDTE.fulfilled, (state, action) => {
			state.isDTEAuthLoading = false;
			state.isDTEAuthSuccess = true;
			state.isDTEAuthError = false;
			state.dteAuth = action.payload;
		});
		builder.addCase(loginWarehouseDTE.rejected, (state, action) => {
			state.isDTEAuthLoading = false;
			state.isDTEAuthSuccess = false;
			state.isDTEAuthError = true;
			state.error = action.error.message;
		});

		builder.addCase(createDTE.pending, state => {
			state.isCreatingDTE = true;
			state.isCreatedDTE = false;
			state.isCreateDTEError = false;
			state.createdDTE = null;
			state.error = null;
		});
		builder.addCase(createDTE.fulfilled, (state, action) => {
			state.isCreatingDTE = false;
			state.isCreatedDTE = true;
			state.isCreateDTEError = false;
			state.createdDTE = action.payload;
		});
		builder.addCase(createDTE.rejected, (state, action) => {
			state.isCreatingDTE = false;
			state.isCreatedDTE = false;
			state.isCreateDTEError = true;
			state.error = action.error.message;
		});

		builder.addCase(readDTEFacele.pending, state => {
			state.isReadingDTEFacele = true;
			state.isReadDTEFacele = false;
			state.isReadDTEFaceleError = false;
			state.dteFacele = null;
			state.error = null;
		});
		builder.addCase(readDTEFacele.fulfilled, (state, action) => {
			state.isReadingDTEFacele = false;
			state.isReadDTEFacele = true;
			state.isReadDTEFaceleError = false;
			state.dteFacele = action.payload;
		});
		builder.addCase(readDTEFacele.rejected, (state, action) => {
			state.isReadingDTEFacele = false;
			state.isReadDTEFacele = false;
			state.isReadDTEFaceleError = true;
			state.error = action.error.message;
		});

		// Create Warehouse Guide
		builder.addCase(createWarehouseGuide.pending, state => {
			state.isLoading = true;
			state.isCreated = false;
		});
		builder.addCase(createWarehouseGuide.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isCreated = true;
			state.currentGuide = action.payload;
		});
		builder.addCase(createWarehouseGuide.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});

		// Get All Warehouse Guides
		builder.addCase(getWarehouseGuides.pending, state => {
			state.isLoading = true;
		});
		builder.addCase(getWarehouseGuides.fulfilled, (state, action) => {
			state.isLoading = false;
			state.guides = action.payload;
		});
		builder.addCase(getWarehouseGuides.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});

		// Get One Warehouse Guide
		builder.addCase(getWarehouseGuide.fulfilled, (state, action) => {
			state.currentGuide = action.payload;
		});

		// Cancel Warehouse Guide
		builder.addCase(cancelWarehouseGuide.fulfilled, (state, action) => {
			const index = state.guides.findIndex(g => g._id === action.payload._id);
			if (index !== -1) {
				state.guides[index] = action.payload;
			}
			if (state.currentGuide?._id === action.payload._id) {
				state.currentGuide = action.payload;
			}
		});
	},
});

export const { clearGuideState } = WarehouseGuideSlice.actions;
export default WarehouseGuideSlice.reducer;
